import { makeStyles } from '@material-ui/core/styles';

export const useProductContainerStyles = makeStyles((theme) => ({
  radio: {
    marginRight: (props) => (props.mobile ? null : 20),
    color: 'black',
    '&.MuiRadio-colorSecondary.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
  textContainer: {
    marginLeft: (props) => (props.mobile ? 10 : 25),
    flexWrap: 'wrap',
    maxWidth: '60%',
  },
  image: {
    width: 75,
    height: 55,
    objectFit: 'cover',
  },
  text: {
    fontSize: 14,
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

export const useProductListStyles = makeStyles((theme) => ({
  container: {
    borderRadius: 5,
    backgroundColor: 'white',
    margin: '30px auto',
    width: '100%',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    '& > span': {
      color: theme.palette.primary.main,
    },
    padding: 17,
    textAlign: 'center',
  },
}));
